window.IRON_SHAFT_SPECS = {
  "nippon-n-s-pro-modus3-tour120-luxury-black-iron-shaft-355-tapered-tip": {
    "launch": "mid-low",
    "spin": "mid",
    "weightMin": 106,
    "weightMax": 120,
    "torque": 1.8,
    "speedMin": 95,
    "speedMax": 112,
    "tip": "355",
    "material": "steel",
    "confidence": "HIGH"
  },
  "nippon-n-s-pro-modus3-tour105-luxury-black-iron-shaft-355-tapered-tip": {
    "launch": "mid",
    "spin": "mid",
    "weightMin": 103,
    "weightMax": 113,
    "torque": 1.6,
    "speedMin": 90,
    "speedMax": 107,
    "tip": "355",
    "material": "steel",
    "confidence": "HIGH"
  },
  "true-temper-amt-white-iron-shaft-0-355-taper-tip-2025": {
    "launch": "low",
    "spin": "mid-low",
    "weightMin": 110,
    "weightMax": 130,
    "torque": 1.8,
    "speedMin": 95,
    "speedMax": 116,
    "tip": "355",
    "material": "steel",
    "confidence": "HIGH"
  },
  "true-temper-amt-black-iron-shaft-0-355-taper-tip-2025": {
    "launch": "mid",
    "spin": "mid",
    "weightMin": 95,
    "weightMax": 115,
    "torque": 1.9,
    "speedMin": 88,
    "speedMax": 108,
    "tip": "355",
    "material": "steel",
    "confidence": "HIGH"
  },
  "true-temper-amt-red-iron-shaft-0-355-taper-tip-2025": {
    "launch": "mid-high",
    "spin": "mid",
    "weightMin": 95,
    "weightMax": 110,
    "torque": 2.0,
    "speedMin": 82,
    "speedMax": 105,
    "tip": "355",
    "material": "steel",
    "confidence": "HIGH"
  },
  "true-temper-elevate-85-black-iron-shaft-0-355-taper-tip": {
    "launch": "mid",
    "spin": "mid",
    "weightMin": 95,
    "weightMax": 110,
    "torque": 1.95,
    "speedMin": 85,
    "speedMax": 105,
    "tip": "355",
    "material": "steel",
    "confidence": "MED"
  },
  "true-temper-elevate-85-black-iron-shaft-0-370-tip-parallel-tip": {
    "launch": "mid",
    "spin": "mid",
    "weightMin": 95,
    "weightMax": 110,
    "torque": 1.95,
    "speedMin": 85,
    "speedMax": 105,
    "tip": "370",
    "material": "steel",
    "confidence": "MED"
  },
  "mitsubishi-mmt-amc-red-iron-shaft": {
    "launch": "mid-high",
    "spin": "mid",
    "weightMin": 55,
    "weightMax": 75,
    "torque": 3.0,
    "speedMin": 70,
    "speedMax": 95,
    "tip": "355",
    "material": "graphite",
    "confidence": "HIGH"
  },
  "mitsubishi-mmt-platinum-iron-shaft": {
    "launch": "mid",
    "spin": "mid",
    "weightMin": 40,
    "weightMax": 90,
    "torque": 3.0,
    "speedMin": 70,
    "speedMax": 100,
    "tip": "370",
    "material": "graphite",
    "confidence": "HIGH"
  },
  "mitsubishi-mmt-amc-blue-iron-shaft": {
    "launch": "mid",
    "spin": "mid",
    "weightMin": 70,
    "weightMax": 90,
    "torque": 3.0,
    "speedMin": 80,
    "speedMax": 105,
    "tip": "355",
    "material": "graphite",
    "confidence": "HIGH"
  },
  "bundles-set-of-7x-nippon-n-s-pro-modus3-tour130-steel-shaft-4-pw": {
    "launch": "mid-high",
    "spin": "low",
    "weightMin": 124,
    "weightMax": 132,
    "torque": 1.4,
    "speedMin": 95,
    "speedMax": 112,
    "tip": "355",
    "material": "steel",
    "confidence": "HIGH"
  },
  "true-temper-dynamic-gold-95-parallel-tip-370": {
    "launch": "mid",
    "spin": "mid",
    "weightMin": 95,
    "weightMax": 99,
    "torque": 1.9,
    "speedMin": 80,
    "speedMax": 100,
    "tip": "370",
    "material": "steel",
    "confidence": "HIGH"
  },
  "true-temper-dynamic-mid-115-iron-shaft-parallel-tip-copy": {
    "launch": "mid",
    "spin": "mid-low",
    "weightMin": 112,
    "weightMax": 118,
    "torque": 1.8,
    "speedMin": 90,
    "speedMax": 108,
    "tip": "370",
    "material": "steel",
    "confidence": "HIGH"
  },
  "true-temper-dynamic-mid-100-parallel": {
    "launch": "mid",
    "spin": "mid",
    "weightMin": 98,
    "weightMax": 103,
    "torque": 1.9,
    "speedMin": 82,
    "speedMax": 102,
    "tip": "370",
    "material": "steel",
    "confidence": "HIGH"
  },
  "true-temper-dynamic-gold-mid-90-shafts-0-370-tip": {
    "launch": "mid",
    "spin": "mid",
    "weightMin": 115,
    "weightMax": 120,
    "torque": 1.8,
    "speedMin": 90,
    "speedMax": 110,
    "tip": "370",
    "material": "steel",
    "confidence": "HIGH"
  },
  "true-temper-dynamic-gold-mid-tour-issue-130-gunmetal-shafts": {
    "launch": "mid",
    "spin": "mid",
    "weightMin": 115,
    "weightMax": 120,
    "torque": 1.8,
    "speedMin": 90,
    "speedMax": 110,
    "tip": "355",
    "material": "steel",
    "confidence": "HIGH"
  },
  "true-temper-dynamic-gold-mid-tour-issue-130-gunmetal-shafts-bundle-sets": {
    "launch": "mid",
    "spin": "mid",
    "weightMin": 115,
    "weightMax": 120,
    "torque": 1.8,
    "speedMin": 90,
    "speedMax": 110,
    "tip": "355",
    "material": "steel",
    "confidence": "HIGH"
  },
  "true-temper-dynamic-gold-mid-tour-issue-115-gunmetal-shafts-bundle-set": {
    "launch": "mid",
    "spin": "mid",
    "weightMin": 115,
    "weightMax": 120,
    "torque": 1.8,
    "speedMin": 90,
    "speedMax": 110,
    "tip": "355",
    "material": "steel",
    "confidence": "HIGH"
  },
  "true-temper-dynamic-gold-tour-issue-mid-130-steel-iron-shaft-bundle-set": {
    "launch": "mid",
    "spin": "mid",
    "weightMin": 115,
    "weightMax": 120,
    "torque": 1.8,
    "speedMin": 90,
    "speedMax": 110,
    "tip": "355",
    "material": "steel",
    "confidence": "HIGH"
  },
  "true-temper-amt-silver-iron-shaft-0-355-tapered-tip": {
    "launch": "mid",
    "spin": "mid",
    "weightMin": 100,
    "weightMax": 120,
    "torque": 1.9,
    "speedMin": 88,
    "speedMax": 110,
    "tip": "355",
    "material": "steel",
    "confidence": "MED"
  },
  "nippon-n-s-pro-850gh-shaft-355-tapered-tip": {
    "launch": "mid-low",
    "spin": "mid-low",
    "weightMin": 110,
    "weightMax": 116,
    "torque": 1.7,
    "speedMin": 95,
    "speedMax": 113,
    "tip": "355",
    "material": "steel",
    "confidence": "MED"
  },
  "nippon-n-s-pro-850gh-shaft-370-parallel-tip": {
    "launch": "mid-low",
    "spin": "mid-low",
    "weightMin": 110,
    "weightMax": 116,
    "torque": 1.7,
    "speedMin": 95,
    "speedMax": 113,
    "tip": "370",
    "material": "steel",
    "confidence": "MED"
  },
  "graphite-design-tour-ad-ut-vf-driving-iron-shaft": {
    "launch": "low",
    "spin": "low",
    "weightMin": 85,
    "weightMax": 95,
    "torque": 2.8,
    "speedMin": 86,
    "speedMax": 110,
    "tip": "355",
    "material": "graphite",
    "confidence": "HIGH"
  },
  "nippon-n-s-pro-modus3-tour110": {
    "launch": "mid-low",
    "spin": "mid",
    "weightMin": 105,
    "weightMax": 115,
    "torque": 1.7,
    "speedMin": 90,
    "speedMax": 107,
    "tip": "355",
    "material": "steel",
    "confidence": "HIGH"
  },
  "recoil-dart-65-iron-shaft-0-355-tapered-tip": {
    "launch": "mid-high",
    "spin": "mid",
    "weightMin": 61,
    "weightMax": 68,
    "torque": 3.1,
    "tip": "355",
    "material": "graphite",
    "confidence": "MED"
  },
  "mitsubishi-vanquish-iron-shaft": {
    "launch": "mid-high",
    "spin": "mid",
    "weightMin": 60,
    "weightMax": 85,
    "torque": 3.5,
    "speedMin": 75,
    "speedMax": 95,
    "tip": "370",
    "material": "graphite",
    "confidence": "MED"
  },
  "recoil-dart-hdc-iron-shaft-0-370-parallel-tip": {
    "launch": "mid",
    "spin": "mid",
    "weightMin": 95,
    "weightMax": 115,
    "torque": 2.8,
    "speedMin": 85,
    "speedMax": 105,
    "tip": "370",
    "material": "graphite",
    "confidence": "MED"
  },
  "ust-recoil-dart-esx-iron-shaft": {
    "launch": "mid-high",
    "spin": "mid",
    "weightMin": 60,
    "weightMax": 80,
    "torque": 3.5,
    "speedMin": 70,
    "speedMax": 92,
    "tip": "370",
    "material": "graphite",
    "confidence": "MED"
  },
  "project-x-red-steel-shaft": {
    "launch": "mid",
    "spin": "mid",
    "weightMin": 115,
    "weightMax": 125,
    "torque": 1.8,
    "speedMin": 90,
    "speedMax": 112,
    "tip": "355",
    "material": "steel",
    "confidence": "MED"
  },
  "true-temper-dynamic-gold-tour-issue-mid-115-iron-steel-shaft-tapered-tip": {
    "launch": "mid",
    "spin": "mid-low",
    "weightMin": 112,
    "weightMax": 118,
    "torque": 1.8,
    "speedMin": 90,
    "speedMax": 108,
    "tip": "355",
    "material": "steel",
    "confidence": "HIGH"
  },
  "nippon-n-s-pro-750gh-neo-steel-shaft-355-tapered-tip": {
    "launch": "high",
    "spin": "mid-high",
    "weightMin": 74,
    "weightMax": 78,
    "torque": 2.35,
    "speedMin": 70,
    "speedMax": 90,
    "tip": "355",
    "material": "steel",
    "confidence": "HIGH"
  },
  "fujikura-sakura-40-iron-hybrid-shaft": {
    "launch": "high",
    "spin": "mid-high",
    "weightMin": 50,
    "weightMax": 75,
    "torque": 3.5,
    "speedMin": 55,
    "speedMax": 85,
    "tip": "370",
    "material": "steel",
    "confidence": "MED"
  },
  "mitsubishi-mmt-taper-iron-shaft-0-355-tip-bundle-set": {
    "launch": "mid",
    "spin": "mid",
    "weightMin": 55,
    "weightMax": 125,
    "torque": 3.0,
    "speedMin": 80,
    "speedMax": 106,
    "tip": "355",
    "material": "graphite",
    "confidence": "HIGH"
  },
  "mitsubishi-mmt-iron-shaft-0-370-tip-bundle-set": {
    "launch": "mid",
    "spin": "mid",
    "weightMin": 55,
    "weightMax": 125,
    "torque": 3.0,
    "speedMin": 80,
    "speedMax": 106,
    "tip": "370",
    "material": "graphite",
    "confidence": "HIGH"
  },
  "fujikura-axiom-iron-shaft-0-355-tip": {
    "launch": "low",
    "spin": "mid-low",
    "weightMin": 75,
    "weightMax": 125,
    "torque": 3.0,
    "speedMin": 80,
    "speedMax": 106,
    "tip": "370",
    "material": "graphite",
    "confidence": "HIGH"
  },
  "assembled-fujikura-axiom-shaft-with-adapter-tip-grip": {
    "launch": "low",
    "spin": "mid-low",
    "weightMin": 75,
    "weightMax": 125,
    "torque": 3.0,
    "speedMin": 80,
    "speedMax": 106,
    "tip": "370",
    "material": "graphite",
    "confidence": "HIGH"
  },
  "nippon-n-s-pro-modus3-tour120-black-matte-355-tapered-tip-bundle-sets": {
    "launch": "mid-low",
    "spin": "mid",
    "weightMin": 106,
    "weightMax": 120,
    "torque": 1.8,
    "speedMin": 95,
    "speedMax": 112,
    "tip": "355",
    "material": "steel",
    "confidence": "HIGH"
  },
  "nippon-n-s-pro-modus3-tour105-black-matte-355-tapered-tip-bundle-sets": {
    "launch": "mid",
    "spin": "mid",
    "weightMin": 103,
    "weightMax": 113,
    "torque": 1.6,
    "speedMin": 90,
    "speedMax": 107,
    "tip": "355",
    "material": "steel",
    "confidence": "HIGH"
  },
  "true-temper-dynamic-gold-tour-issue-steel-iron-shaft-bundle-sets": {
    "launch": "low",
    "spin": "low",
    "weightMin": 128,
    "weightMax": 132,
    "torque": 1.6,
    "speedMin": 95,
    "speedMax": 118,
    "tip": "355",
    "material": "steel",
    "confidence": "HIGH"
  },
  "true-temper-dynamic-gold-tour-issue-105-steel-iron-shaft-bundle-sets": {
    "launch": "low",
    "spin": "low",
    "weightMin": 128,
    "weightMax": 132,
    "torque": 1.6,
    "speedMin": 95,
    "speedMax": 118,
    "tip": "355",
    "material": "steel",
    "confidence": "HIGH"
  },
  "true-temper-dynamic-gold-tour-issue-120-steel-iron-shaft-bundle-set": {
    "launch": "low",
    "spin": "mid-low",
    "weightMin": 118,
    "weightMax": 125,
    "torque": 1.7,
    "speedMin": 92,
    "speedMax": 114,
    "tip": "355",
    "material": "steel",
    "confidence": "HIGH"
  },
  "true-temper-dynamic-gold-tour-issue-black-onyx-steel-shaft-bundle-set": {
    "launch": "mid",
    "spin": "mid",
    "weightMin": 120,
    "weightMax": 130,
    "torque": 1.7,
    "speedMin": 90,
    "speedMax": 112,
    "tip": "355",
    "material": "steel",
    "confidence": "MED"
  },
  "kbs-tour-lite-black-pvd-steel-shafts": {
    "launch": "mid-high",
    "spin": "mid",
    "weightMin": 95,
    "weightMax": 110,
    "torque": 1.9,
    "speedMin": 85,
    "speedMax": 107,
    "tip": "355",
    "material": "steel",
    "confidence": "MED"
  },
  "ust-recoil-780-es-smacwrap-iron-shaft-black-finish": {
    "launch": "mid-high",
    "spin": "mid",
    "weightMin": 75,
    "weightMax": 82,
    "torque": 3.3,
    "speedMin": 75,
    "speedMax": 95,
    "tip": "370",
    "material": "graphite",
    "confidence": "HIGH"
  },
  "ust-recoil-760-es-smacwrap-iron-shaft-black-finish": {
    "launch": "mid-high",
    "spin": "mid",
    "weightMin": 75,
    "weightMax": 82,
    "torque": 3.3,
    "speedMin": 75,
    "speedMax": 95,
    "tip": "370",
    "material": "graphite",
    "confidence": "HIGH"
  },
  "kbs-hi-rev-2-0-wedge-shaft-355-tip-black-gloss-finish": {
    "launch": "mid",
    "spin": "mid",
    "weightMin": 110,
    "weightMax": 130,
    "torque": 1.7,
    "speedMin": 90,
    "speedMax": 112,
    "tip": "355",
    "material": "steel",
    "confidence": "MED"
  },
  "new-aldila-nv-23-iron-shaft": {
    "launch": "mid",
    "spin": "mid",
    "weightMin": 95,
    "weightMax": 115,
    "torque": 2.5,
    "speedMin": 82,
    "speedMax": 105,
    "tip": "370",
    "material": "graphite",
    "confidence": "LOW"
  },
  "ust-dart-v-tapered-iron-shaft": {
    "launch": "mid",
    "spin": "mid",
    "weightMin": 95,
    "weightMax": 115,
    "torque": 2.8,
    "speedMin": 85,
    "speedMax": 105,
    "tip": "355",
    "material": "graphite",
    "confidence": "MED"
  },
  "new-project-x-u-steel-iron-shaft-0-370-tip": {
    "launch": "low",
    "spin": "low",
    "weightMin": 115,
    "weightMax": 125,
    "torque": 1.7,
    "speedMin": 95,
    "speedMax": 115,
    "tip": "370",
    "material": "steel",
    "confidence": "MED"
  },
  "fujikura-axiom-iron-shaft": {
    "launch": "low",
    "spin": "mid-low",
    "weightMin": 75,
    "weightMax": 125,
    "torque": 3.0,
    "speedMin": 80,
    "speedMax": 106,
    "tip": "370",
    "material": "graphite",
    "confidence": "HIGH"
  },
  "true-temper-dynamic-gold-tour-issue-mid-130-iron-steel-shaft-tapered-tip": {
    "launch": "mid",
    "spin": "mid",
    "weightMin": 115,
    "weightMax": 120,
    "torque": 1.8,
    "speedMin": 90,
    "speedMax": 110,
    "tip": "355",
    "material": "steel",
    "confidence": "HIGH"
  },
  "true-temper-dynamic-gold-mid-115-iron-steel-shaft-tapered-tip": {
    "launch": "mid",
    "spin": "mid-low",
    "weightMin": 112,
    "weightMax": 118,
    "torque": 1.8,
    "speedMin": 90,
    "speedMax": 108,
    "tip": "355",
    "material": "steel",
    "confidence": "HIGH"
  },
  "true-temper-dynamic-gold-mid-100-iron-steel-shaft-tapered-tip": {
    "launch": "mid",
    "spin": "mid",
    "weightMin": 98,
    "weightMax": 103,
    "torque": 1.9,
    "speedMin": 82,
    "speedMax": 102,
    "tip": "355",
    "material": "steel",
    "confidence": "HIGH"
  },
  "new-true-temper-elevate-95-mph-steel-iron-shaft-0-355-taper-tip": {
    "launch": "mid-high",
    "spin": "mid",
    "weightMin": 95,
    "weightMax": 100,
    "torque": 2.0,
    "speedMin": 80,
    "speedMax": 98,
    "tip": "355",
    "material": "steel",
    "confidence": "HIGH"
  },
  "true-temper-elevate-95-v2-mph-steel-shaft-0-370-parallel-tip": {
    "launch": "mid-high",
    "spin": "mid",
    "weightMin": 95,
    "weightMax": 100,
    "torque": 2.0,
    "speedMin": 80,
    "speedMax": 98,
    "tip": "370",
    "material": "steel",
    "confidence": "HIGH"
  },
  "true-temper-elevate-85-v2mph-steel-shaft-0-370-parallel-tip": {
    "launch": "mid-high",
    "spin": "mid",
    "weightMin": 95,
    "weightMax": 100,
    "torque": 2.0,
    "speedMin": 80,
    "speedMax": 98,
    "tip": "370",
    "material": "steel",
    "confidence": "HIGH"
  },
  "new-true-temper-dynamic-gold-95-steel-iron-shaft": {
    "launch": "mid",
    "spin": "mid",
    "weightMin": 95,
    "weightMax": 99,
    "torque": 1.9,
    "speedMin": 80,
    "speedMax": 100,
    "tip": "355",
    "material": "steel",
    "confidence": "HIGH"
  },
  "assembled-mitsubishi-mmt-utility-iron-shaft-0-355-tip-adapter-tip-grip": {
    "launch": "mid",
    "spin": "mid",
    "weightMin": 55,
    "weightMax": 125,
    "torque": 3.0,
    "speedMin": 80,
    "speedMax": 106,
    "tip": "355",
    "material": "graphite",
    "confidence": "HIGH"
  },
  "assembled-graphite-design-tour-ad-95-iron-shaft-adapter-tip-grip": {
    "launch": "low",
    "spin": "low",
    "weightMin": 85,
    "weightMax": 95,
    "torque": 2.8,
    "speedMin": 86,
    "speedMax": 110,
    "tip": "355",
    "material": "graphite",
    "confidence": "HIGH"
  },
  "assembled-graphite-design-tour-ad-85-iron-shaft-adapter-tip-grip": {
    "launch": "low",
    "spin": "low",
    "weightMin": 85,
    "weightMax": 95,
    "torque": 2.8,
    "speedMin": 86,
    "speedMax": 110,
    "tip": "355",
    "material": "graphite",
    "confidence": "HIGH"
  },
  "kbs-pgi-players-graphite-iron-shaft-0-355-tip": {
    "launch": "mid",
    "spin": "mid",
    "weightMin": 50,
    "weightMax": 100,
    "torque": 2.5,
    "speedMin": 57,
    "speedMax": 94,
    "tip": "355",
    "material": "graphite",
    "confidence": "HIGH"
  },
  "new-ust-helium-nanocore-iron-shafts": {
    "launch": "mid",
    "spin": "mid",
    "weightMin": 88,
    "weightMax": 110,
    "torque": 3.0,
    "speedMin": 80,
    "speedMax": 102,
    "tip": "370",
    "material": "graphite",
    "confidence": "MED"
  },
  "recoil-dart-90-iron-shaft-0-355-tapered-tip": {
    "launch": "mid",
    "spin": "mid",
    "weightMin": 90,
    "weightMax": 90,
    "torque": 2.0,
    "tip": "355",
    "material": "graphite",
    "confidence": "MED"
  },
  "recoil-dart-105-iron-shaft-0-355-tapered-tip": {
    "launch": "mid",
    "spin": "mid",
    "weightMin": 106,
    "weightMax": 106,
    "torque": 2.0,
    "tip": "355",
    "material": "graphite",
    "confidence": "MED"
  },
  "true-temper-dynamic-gold-115-spinner-wedge-steel-shaft": {
    "launch": "low",
    "spin": "low",
    "weightMin": 128,
    "weightMax": 132,
    "torque": 1.6,
    "speedMin": 95,
    "speedMax": 118,
    "tip": "355",
    "material": "steel",
    "confidence": "HIGH"
  },
  "true-temper-dynamic-gold-tour-issue-spinner-wedge-steel-shaft": {
    "launch": "low",
    "spin": "low",
    "weightMin": 128,
    "weightMax": 132,
    "torque": 1.6,
    "speedMin": 95,
    "speedMax": 118,
    "tip": "355",
    "material": "steel",
    "confidence": "HIGH"
  },
  "ust-proforce-gold-115-rv2-iron-shaft-0-370-tip": {
    "launch": "mid",
    "spin": "mid",
    "weightMin": 75,
    "weightMax": 95,
    "torque": 3.3,
    "speedMin": 80,
    "speedMax": 100,
    "tip": "370",
    "material": "graphite",
    "confidence": "MED"
  },
  "true-temper-dynamic-gold-tour-issue-black-onyx-steel-shaft": {
    "launch": "mid",
    "spin": "mid",
    "weightMin": 120,
    "weightMax": 130,
    "torque": 1.7,
    "speedMin": 90,
    "speedMax": 112,
    "tip": "355",
    "material": "steel",
    "confidence": "MED"
  },
  "ust-proforce-v2-95-iron-shaft-0-370-tip": {
    "launch": "mid",
    "spin": "mid",
    "weightMin": 88,
    "weightMax": 99,
    "torque": 3.0,
    "speedMin": 80,
    "speedMax": 98,
    "tip": "370",
    "material": "graphite",
    "confidence": "HIGH"
  },
  "ust-proforce-lady-lite-iron-graphite-shaft": {
    "launch": "high",
    "spin": "high",
    "weightMin": 50,
    "weightMax": 60,
    "torque": 5.0,
    "speedMin": 55,
    "speedMax": 78,
    "tip": "370",
    "material": "graphite",
    "confidence": "MED"
  },
  "true-temper-elevate-tour-black-onyx-with-vss-pro-steel-iron-shaft-0-355-taper-tip": {
    "launch": "mid",
    "spin": "mid",
    "weightMin": 110,
    "weightMax": 125,
    "torque": 1.7,
    "speedMin": 92,
    "speedMax": 112,
    "tip": "355",
    "material": "steel",
    "confidence": "MED"
  },
  "nippon-n-s-pro-850gh-neo-steel-shaft-355-tapered-tip": {
    "launch": "mid-high",
    "spin": "mid-high",
    "weightMin": 84,
    "weightMax": 88,
    "torque": 2.05,
    "speedMin": 80,
    "speedMax": 98,
    "tip": "355",
    "material": "steel",
    "confidence": "HIGH"
  },
  "true-temper-commercial-grade-iron-steel-shaft-r-s-combo-0-370-parallel-tip": {
    "launch": "mid",
    "spin": "mid",
    "weightMin": 120,
    "weightMax": 130,
    "torque": 1.8,
    "speedMin": 90,
    "speedMax": 110,
    "tip": "370",
    "material": "steel",
    "confidence": "LOW"
  },
  "true-temper-dynamic-gold-tour-issue-usa-wedge-steel-shaft": {
    "launch": "low",
    "spin": "low",
    "weightMin": 128,
    "weightMax": 132,
    "torque": 1.6,
    "speedMin": 95,
    "speedMax": 118,
    "tip": "355",
    "material": "steel",
    "confidence": "HIGH"
  },
  "new-true-temper-elevate-tour-steel-shaft-0-355-taper-tip": {
    "launch": "mid",
    "spin": "mid",
    "weightMin": 110,
    "weightMax": 130,
    "torque": 1.7,
    "speedMin": 90,
    "speedMax": 112,
    "tip": "355",
    "material": "steel",
    "confidence": "MED"
  },
  "bundles-set-of-7x-nippon-n-s-pro-modus3-tour105-steel-shaft-4-pw": {
    "launch": "mid",
    "spin": "mid",
    "weightMin": 103,
    "weightMax": 113,
    "torque": 1.6,
    "speedMin": 90,
    "speedMax": 107,
    "tip": "355",
    "material": "steel",
    "confidence": "HIGH"
  },
  "ust-attas-speed-t1100g-iron-shafts": {
    "launch": "mid",
    "spin": "mid",
    "weightMin": 105,
    "weightMax": 115,
    "torque": 2.8,
    "speedMin": 85,
    "speedMax": 105,
    "tip": "370",
    "material": "graphite",
    "confidence": "HIGH"
  },
  "bundle-set-of-8x-true-temper-dynamic-gold-x7-steel-shafts": {
    "launch": "low",
    "spin": "low",
    "weightMin": 128,
    "weightMax": 135,
    "torque": 1.7,
    "speedMin": 100,
    "speedMax": 120,
    "tip": "355",
    "material": "steel",
    "confidence": "MED"
  },
  "mitsubishi-ot-iron-shaft-new-black-finish": {
    "launch": "mid",
    "spin": "mid",
    "weightMin": 95,
    "weightMax": 120,
    "torque": 2.5,
    "speedMin": 85,
    "speedMax": 108,
    "tip": "370",
    "material": "graphite",
    "confidence": "MED"
  },
  "nippon-n-s-pro-modus3-tour120-black-matte": {
    "launch": "mid-low",
    "spin": "mid",
    "weightMin": 106,
    "weightMax": 120,
    "torque": 1.8,
    "speedMin": 95,
    "speedMax": 112,
    "tip": "355",
    "material": "steel",
    "confidence": "HIGH"
  },
  "nippon-ns-pro-modus3-tour105-black-matte": {
    "launch": "mid",
    "spin": "mid",
    "weightMin": 103,
    "weightMax": 113,
    "torque": 1.6,
    "speedMin": 90,
    "speedMax": 107,
    "tip": "355",
    "material": "steel",
    "confidence": "HIGH"
  },
  "nippon-n-s-pro-modus3-tour115": {
    "launch": "mid",
    "spin": "mid",
    "weightMin": 112,
    "weightMax": 121,
    "torque": 1.7,
    "speedMin": 90,
    "speedMax": 107,
    "tip": "355",
    "material": "steel",
    "confidence": "HIGH"
  },
  "kbs-tour-lite-steel-shafts": {
    "launch": "mid-high",
    "spin": "mid",
    "weightMin": 95,
    "weightMax": 110,
    "torque": 1.9,
    "speedMin": 85,
    "speedMax": 107,
    "tip": "355",
    "material": "steel",
    "confidence": "MED"
  },
  "kbs-tour-lite-steel-shafts-parallel-tip": {
    "launch": "mid-high",
    "spin": "mid",
    "weightMin": 95,
    "weightMax": 110,
    "torque": 1.9,
    "speedMin": 85,
    "speedMax": 107,
    "tip": "370",
    "material": "steel",
    "confidence": "MED"
  },
  "true-temper-elevate-95-mph-steel-shaft-0-355-taper-tip": {
    "launch": "mid-high",
    "spin": "mid",
    "weightMin": 95,
    "weightMax": 100,
    "torque": 2.0,
    "speedMin": 80,
    "speedMax": 98,
    "tip": "355",
    "material": "steel",
    "confidence": "HIGH"
  },
  "true-temper-elevate-95-mph-steel-shaft-0-370-parallel-tip": {
    "launch": "mid-high",
    "spin": "mid",
    "weightMin": 95,
    "weightMax": 100,
    "torque": 2.0,
    "speedMin": 80,
    "speedMax": 98,
    "tip": "370",
    "material": "steel",
    "confidence": "HIGH"
  },
  "true-temper-elevate-85-mph-steel-shaft-0-370-parallel-tip": {
    "launch": "mid-high",
    "spin": "mid",
    "weightMin": 95,
    "weightMax": 100,
    "torque": 2.0,
    "speedMin": 80,
    "speedMax": 98,
    "tip": "370",
    "material": "steel",
    "confidence": "HIGH"
  },
  "true-temper-dynamic-gold-x7-steel-shaft": {
    "launch": "low",
    "spin": "low",
    "weightMin": 128,
    "weightMax": 135,
    "torque": 1.7,
    "speedMin": 100,
    "speedMax": 120,
    "tip": "355",
    "material": "steel",
    "confidence": "MED"
  },
  "true-temper-dynamic-gold-95-vsspro-steel-shaft": {
    "launch": "mid",
    "spin": "mid",
    "weightMin": 95,
    "weightMax": 99,
    "torque": 1.9,
    "speedMin": 80,
    "speedMax": 100,
    "tip": "355",
    "material": "steel",
    "confidence": "HIGH"
  },
  "true-temper-dynamic-gold-tour-issue-120-steel-shaft": {
    "launch": "low",
    "spin": "mid-low",
    "weightMin": 118,
    "weightMax": 125,
    "torque": 1.7,
    "speedMin": 92,
    "speedMax": 114,
    "tip": "355",
    "material": "steel",
    "confidence": "HIGH"
  },
  "true-temper-dynamic-gold-tour-issue-105-steel-shaft": {
    "launch": "low",
    "spin": "low",
    "weightMin": 128,
    "weightMax": 132,
    "torque": 1.6,
    "speedMin": 95,
    "speedMax": 118,
    "tip": "355",
    "material": "steel",
    "confidence": "HIGH"
  },
  "kbs-tour-90-shaft-370-tip-r-s-combo": {
    "launch": "mid",
    "spin": "mid",
    "weightMin": 110,
    "weightMax": 130,
    "torque": 1.7,
    "speedMin": 90,
    "speedMax": 112,
    "tip": "370",
    "material": "steel",
    "confidence": "MED"
  },
  "graphite-design-tour-ad-115-iron-shaft": {
    "launch": "mid",
    "spin": "mid",
    "weightMin": 50,
    "weightMax": 115,
    "torque": 3.0,
    "speedMin": 75,
    "speedMax": 108,
    "tip": "355",
    "material": "graphite",
    "confidence": "HIGH"
  },
  "graphite-design-tour-ad-105-iron-shaft": {
    "launch": "mid",
    "spin": "mid",
    "weightMin": 50,
    "weightMax": 115,
    "torque": 3.0,
    "speedMin": 75,
    "speedMax": 108,
    "tip": "355",
    "material": "graphite",
    "confidence": "HIGH"
  },
  "aerotech-steelfiber-fc70-parallel-iron-shaft-0-370-tip-bundle-set-3-pw": {
    "launch": "mid-high",
    "spin": "mid",
    "weightMin": 70,
    "weightMax": 80,
    "torque": 2.9,
    "speedMin": 68,
    "speedMax": 90,
    "tip": "370",
    "material": "composite",
    "confidence": "MED"
  },
  "aerotech-steelfiber-fc80-parallel-iron-shaft-0-370-tip-bundle-set-3-pw": {
    "launch": "mid-high",
    "spin": "mid",
    "weightMin": 78,
    "weightMax": 86,
    "torque": 2.7,
    "speedMin": 72,
    "speedMax": 92,
    "tip": "370",
    "material": "composite",
    "confidence": "MED"
  },
  "aerotech-steelfiber-fc115-iron-shaft-tapered-355-tip-bundle-set-3-pw": {
    "launch": "mid",
    "spin": "mid-low",
    "weightMin": 110,
    "weightMax": 120,
    "torque": 2.2,
    "speedMin": 90,
    "speedMax": 110,
    "tip": "355",
    "material": "composite",
    "confidence": "MED"
  },
  "aerotech-steelfiber-fc115-iron-shaft-parallel-370-tip-bundle-set-3-pw": {
    "launch": "mid",
    "spin": "mid-low",
    "weightMin": 110,
    "weightMax": 120,
    "torque": 2.2,
    "speedMin": 90,
    "speedMax": 110,
    "tip": "370",
    "material": "composite",
    "confidence": "MED"
  },
  "aerotech-steelfiber-fc90-iron-shaft-tapered-355-tip-bundle-set-3-pw": {
    "launch": "mid-high",
    "spin": "mid",
    "weightMin": 85,
    "weightMax": 95,
    "torque": 2.6,
    "speedMin": 75,
    "speedMax": 96,
    "tip": "355",
    "material": "composite",
    "confidence": "HIGH"
  },
  "aerotech-steelfiber-fc90-iron-shaft-parallel-370-tip-bundle-set-3-pw": {
    "launch": "mid-high",
    "spin": "mid",
    "weightMin": 85,
    "weightMax": 95,
    "torque": 2.6,
    "speedMin": 75,
    "speedMax": 96,
    "tip": "370",
    "material": "composite",
    "confidence": "HIGH"
  },
  "aerotech-steelfiber-iron-shaft-bundle-set-3-pw": {
    "launch": "mid",
    "spin": "mid-low",
    "weightMin": 90,
    "weightMax": 98,
    "torque": 2.5,
    "speedMin": 80,
    "speedMax": 102,
    "tip": "370",
    "material": "composite",
    "confidence": "MED"
  },
  "new-aldila-nv-iron-shaft": {
    "launch": "mid",
    "spin": "mid",
    "weightMin": 95,
    "weightMax": 115,
    "torque": 2.5,
    "speedMin": 82,
    "speedMax": 105,
    "tip": "370",
    "material": "graphite",
    "confidence": "LOW"
  },
  "kbs-tour-taper-lite-shaft-370-tip": {
    "launch": "mid",
    "spin": "mid",
    "weightMin": 105,
    "weightMax": 115,
    "torque": 1.85,
    "speedMin": 88,
    "speedMax": 107,
    "tip": "370",
    "material": "steel",
    "confidence": "HIGH"
  },
  "kbs-tour-taper-lite-shaft-355-tip": {
    "launch": "mid",
    "spin": "mid",
    "weightMin": 105,
    "weightMax": 115,
    "torque": 1.85,
    "speedMin": 88,
    "speedMax": 107,
    "tip": "355",
    "material": "steel",
    "confidence": "HIGH"
  },
  "kbs-pgi-players-graphite-iron-shaft-0-370-tip": {
    "launch": "mid",
    "spin": "mid",
    "weightMin": 50,
    "weightMax": 100,
    "torque": 2.5,
    "speedMin": 57,
    "speedMax": 94,
    "tip": "370",
    "material": "graphite",
    "confidence": "HIGH"
  },
  "true-temper-elevate-ets-95-0-355-taper-tip": {
    "launch": "mid-high",
    "spin": "mid",
    "weightMin": 95,
    "weightMax": 100,
    "torque": 2.0,
    "speedMin": 80,
    "speedMax": 98,
    "tip": "355",
    "material": "steel",
    "confidence": "HIGH"
  },
  "true-temper-elevate-ets-115-0-355-taper-tip": {
    "launch": "mid-high",
    "spin": "mid",
    "weightMin": 95,
    "weightMax": 105,
    "torque": 1.95,
    "speedMin": 82,
    "speedMax": 102,
    "tip": "355",
    "material": "steel",
    "confidence": "MED"
  },
  "true-temper-elevate-ets-95-0-370-parallel-tip": {
    "launch": "mid-high",
    "spin": "mid",
    "weightMin": 95,
    "weightMax": 100,
    "torque": 2.0,
    "speedMin": 80,
    "speedMax": 98,
    "tip": "370",
    "material": "steel",
    "confidence": "HIGH"
  },
  "true-temper-elevate-ets-85-0-370-parallel-tip": {
    "launch": "mid-high",
    "spin": "mid",
    "weightMin": 95,
    "weightMax": 105,
    "torque": 1.95,
    "speedMin": 82,
    "speedMax": 102,
    "tip": "370",
    "material": "steel",
    "confidence": "MED"
  },
  "nippon-n-s-pro-zelos-6-steel-shaft-wedge": {
    "launch": "high",
    "spin": "mid-high",
    "weightMin": 68,
    "weightMax": 75,
    "torque": 2.6,
    "speedMin": 60,
    "speedMax": 84,
    "tip": "370",
    "material": "steel",
    "confidence": "HIGH"
  },
  "recoil-dart-iron-shaft-0-370-parallel-tip": {
    "launch": "mid",
    "spin": "mid",
    "weightMin": 95,
    "weightMax": 115,
    "torque": 2.8,
    "speedMin": 85,
    "speedMax": 105,
    "tip": "370",
    "material": "graphite",
    "confidence": "MED"
  },
  "new-fujikura-vista-pro-iron-shaft": {
    "launch": "mid-high",
    "spin": "mid",
    "weightMin": 55,
    "weightMax": 80,
    "torque": 3.5,
    "speedMin": 70,
    "speedMax": 92,
    "tip": "370",
    "material": "graphite",
    "confidence": "MED"
  },
  "kbs-max-65-graphite-iron-shaft-355-tip": {
    "launch": "high",
    "spin": "high",
    "weightMin": 45,
    "weightMax": 85,
    "torque": 3.4,
    "speedMin": 51,
    "speedMax": 82,
    "tip": "355",
    "material": "graphite",
    "confidence": "HIGH"
  },
  "kbs-max-55-graphite-iron-shaft-355-tip": {
    "launch": "high",
    "spin": "high",
    "weightMin": 45,
    "weightMax": 85,
    "torque": 3.4,
    "speedMin": 51,
    "speedMax": 82,
    "tip": "355",
    "material": "graphite",
    "confidence": "HIGH"
  },
  "kbs-max-graphite-iron-shaft-355-tip": {
    "launch": "high",
    "spin": "high",
    "weightMin": 45,
    "weightMax": 85,
    "torque": 3.4,
    "speedMin": 51,
    "speedMax": 82,
    "tip": "355",
    "material": "graphite",
    "confidence": "HIGH"
  },
  "mitsubishi-mmt-utility-iron-shaft-0-355-tip": {
    "launch": "mid",
    "spin": "mid",
    "weightMin": 55,
    "weightMax": 125,
    "torque": 3.0,
    "speedMin": 80,
    "speedMax": 106,
    "tip": "355",
    "material": "graphite",
    "confidence": "HIGH"
  },
  "project-x-io-steel-shaft": {
    "launch": "mid-low",
    "spin": "mid",
    "weightMin": 110,
    "weightMax": 120,
    "torque": 1.8,
    "speedMin": 92,
    "speedMax": 112,
    "tip": "355",
    "material": "steel",
    "confidence": "MED"
  },
  "project-x-ls-steel-shaft": {
    "launch": "low",
    "spin": "low",
    "weightMin": 115,
    "weightMax": 120,
    "torque": 1.7,
    "speedMin": 95,
    "speedMax": 114,
    "tip": "355",
    "material": "steel",
    "confidence": "HIGH"
  },
  "kbs-hi-rev-2-0-wedge-shaft-355-tip-major-green-edition": {
    "launch": "mid",
    "spin": "mid",
    "weightMin": 110,
    "weightMax": 130,
    "torque": 1.7,
    "speedMin": 90,
    "speedMax": 112,
    "tip": "355",
    "material": "steel",
    "confidence": "MED"
  },
  "mitsubishi-mmt-taper-scoring-wedge-shaft-0-355-tip": {
    "launch": "mid",
    "spin": "mid",
    "weightMin": 55,
    "weightMax": 125,
    "torque": 3.0,
    "speedMin": 80,
    "speedMax": 106,
    "tip": "355",
    "material": "graphite",
    "confidence": "HIGH"
  },
  "project-x-rifle-steel-shaft-0-355-tip-blackout-finish": {
    "launch": "mid",
    "spin": "mid",
    "weightMin": 115,
    "weightMax": 125,
    "torque": 1.8,
    "speedMin": 90,
    "speedMax": 112,
    "tip": "355",
    "material": "steel",
    "confidence": "MED"
  },
  "project-x-lz-steel-shaft-blackout-finish": {
    "launch": "mid",
    "spin": "mid",
    "weightMin": 115,
    "weightMax": 125,
    "torque": 1.8,
    "speedMin": 92,
    "speedMax": 112,
    "tip": "355",
    "material": "steel",
    "confidence": "HIGH"
  },
  "mitsubishi-mmt-taper-iron-shaft-0-355-tip": {
    "launch": "mid",
    "spin": "mid",
    "weightMin": 55,
    "weightMax": 125,
    "torque": 3.0,
    "speedMin": 80,
    "speedMax": 106,
    "tip": "355",
    "material": "graphite",
    "confidence": "HIGH"
  },
  "nippon-n-s-pro-950gh-neo-steel-shaft-370-parallel-tip": {
    "launch": "mid-high",
    "spin": "mid-high",
    "weightMin": 94,
    "weightMax": 104,
    "torque": 1.9,
    "speedMin": 85,
    "speedMax": 103,
    "tip": "370",
    "material": "steel",
    "confidence": "HIGH"
  },
  "nippon-n-s-pro-950gh-neo-steel-shaft-355-tapered-tip": {
    "launch": "mid-high",
    "spin": "mid-high",
    "weightMin": 94,
    "weightMax": 104,
    "torque": 1.9,
    "speedMin": 85,
    "speedMax": 103,
    "tip": "355",
    "material": "steel",
    "confidence": "HIGH"
  },
  "project-x-catalyst-graphite-iron-shaft-0-370-parallel-tip": {
    "launch": "mid",
    "spin": "mid",
    "weightMin": 57,
    "weightMax": 100,
    "torque": 4.5,
    "speedMin": 75,
    "speedMax": 107,
    "tip": "370",
    "material": "graphite",
    "confidence": "HIGH"
  },
  "true-temper-elevate-tour-with-vss-pro-steel-shaft-0-355-taper-tip": {
    "launch": "mid",
    "spin": "mid",
    "weightMin": 110,
    "weightMax": 125,
    "torque": 1.7,
    "speedMin": 92,
    "speedMax": 112,
    "tip": "355",
    "material": "steel",
    "confidence": "MED"
  },
  "true-temper-elevate-95-with-vss-steel-shaft-0-355-taper-tip": {
    "launch": "mid-high",
    "spin": "mid",
    "weightMin": 95,
    "weightMax": 100,
    "torque": 2.0,
    "speedMin": 80,
    "speedMax": 98,
    "tip": "355",
    "material": "steel",
    "confidence": "HIGH"
  },
  "true-temper-elevate-105-with-vss-pro-steel-shaft-0-370-parallel-tip": {
    "launch": "mid-high",
    "spin": "mid",
    "weightMin": 95,
    "weightMax": 105,
    "torque": 1.95,
    "speedMin": 82,
    "speedMax": 102,
    "tip": "370",
    "material": "steel",
    "confidence": "MED"
  },
  "true-temper-elevate-95-with-vss-steel-shaft-0-370-parallel-tip": {
    "launch": "mid-high",
    "spin": "mid",
    "weightMin": 95,
    "weightMax": 100,
    "torque": 2.0,
    "speedMin": 80,
    "speedMax": 98,
    "tip": "370",
    "material": "steel",
    "confidence": "HIGH"
  },
  "kbs-max-graphite-iron-shaft-370-tip": {
    "launch": "high",
    "spin": "high",
    "weightMin": 45,
    "weightMax": 85,
    "torque": 3.4,
    "speedMin": 51,
    "speedMax": 82,
    "tip": "370",
    "material": "graphite",
    "confidence": "HIGH"
  },
  "nippon-n-s-pro-modus3-tour130-355-parallel-tip": {
    "launch": "mid-high",
    "spin": "low",
    "weightMin": 124,
    "weightMax": 132,
    "torque": 1.4,
    "speedMin": 95,
    "speedMax": 112,
    "tip": "370",
    "material": "steel",
    "confidence": "HIGH"
  },
  "nippon-n-s-pro-950gh-steel-shaft-0370-tip": {
    "launch": "mid-low",
    "spin": "mid-low",
    "weightMin": 110,
    "weightMax": 116,
    "torque": 1.7,
    "speedMin": 95,
    "speedMax": 113,
    "tip": "370",
    "material": "steel",
    "confidence": "MED"
  },
  "graphite-design-tour-ad-95-iron-shaft-1": {
    "launch": "low",
    "spin": "low",
    "weightMin": 85,
    "weightMax": 95,
    "torque": 2.8,
    "speedMin": 86,
    "speedMax": 110,
    "tip": "355",
    "material": "graphite",
    "confidence": "HIGH"
  },
  "apollo-shadow-steel-shaft": {
    "launch": "mid",
    "spin": "mid",
    "weightMin": 115,
    "weightMax": 130,
    "torque": 1.9,
    "speedMin": 88,
    "speedMax": 110,
    "tip": "370",
    "material": "steel",
    "confidence": "LOW"
  },
  "nippon-n-s-pro-950gh-wf-steel-shaft": {
    "launch": "mid-low",
    "spin": "mid-low",
    "weightMin": 110,
    "weightMax": 116,
    "torque": 1.7,
    "speedMin": 95,
    "speedMax": 113,
    "tip": "355",
    "material": "steel",
    "confidence": "MED"
  },
  "nippon-n-s-pro-1050gh-steel-shaft": {
    "launch": "mid-low",
    "spin": "mid-low",
    "weightMin": 110,
    "weightMax": 116,
    "torque": 1.7,
    "speedMin": 95,
    "speedMax": 113,
    "tip": "355",
    "material": "steel",
    "confidence": "MED"
  },
  "nippon-n-s-pro-850gh-steel-shaft": {
    "launch": "mid-low",
    "spin": "mid-low",
    "weightMin": 110,
    "weightMax": 116,
    "torque": 1.7,
    "speedMin": 95,
    "speedMax": 113,
    "tip": "355",
    "material": "steel",
    "confidence": "MED"
  },
  "nippon-n-s-pro-750gh-wrap-tech-steel-shaft": {
    "launch": "mid-low",
    "spin": "mid-low",
    "weightMin": 110,
    "weightMax": 116,
    "torque": 1.7,
    "speedMin": 95,
    "speedMax": 113,
    "tip": "355",
    "material": "steel",
    "confidence": "MED"
  },
  "true-temper-dynalite-gold-iron-steel-shaft-r-s-combo": {
    "launch": "mid-high",
    "spin": "mid-high",
    "weightMin": 95,
    "weightMax": 108,
    "torque": 1.9,
    "speedMin": 80,
    "speedMax": 100,
    "tip": "370",
    "material": "steel",
    "confidence": "HIGH"
  },
  "mitsubishi-ot-iron-shaft": {
    "launch": "mid",
    "spin": "mid",
    "weightMin": 95,
    "weightMax": 120,
    "torque": 2.5,
    "speedMin": 85,
    "speedMax": 108,
    "tip": "370",
    "material": "graphite",
    "confidence": "MED"
  },
  "mitsubishi-mmt-iron-shaft": {
    "launch": "mid",
    "spin": "mid",
    "weightMin": 55,
    "weightMax": 125,
    "torque": 3.0,
    "speedMin": 80,
    "speedMax": 106,
    "tip": "370",
    "material": "graphite",
    "confidence": "HIGH"
  },
  "kbs-tour-taper-shaft-bundle-set-of-8x-shafts": {
    "launch": "mid-low",
    "spin": "mid-low",
    "weightMin": 115,
    "weightMax": 130,
    "torque": 1.7,
    "speedMin": 95,
    "speedMax": 113,
    "tip": "355",
    "material": "steel",
    "confidence": "HIGH"
  },
  "kbs-tour-taper-shaft-black-pvd-bundle-set-of-8x-shafts": {
    "launch": "mid-low",
    "spin": "mid-low",
    "weightMin": 115,
    "weightMax": 130,
    "torque": 1.7,
    "speedMin": 95,
    "speedMax": 113,
    "tip": "355",
    "material": "steel",
    "confidence": "HIGH"
  },
  "fujikura-vista-pro-iron-shaft": {
    "launch": "mid-high",
    "spin": "mid",
    "weightMin": 55,
    "weightMax": 80,
    "torque": 3.5,
    "speedMin": 70,
    "speedMax": 92,
    "tip": "370",
    "material": "graphite",
    "confidence": "MED"
  },
  "fujikura-pro-115-iron-shaft": {
    "launch": "mid",
    "spin": "mid",
    "weightMin": 80,
    "weightMax": 110,
    "torque": 3.0,
    "speedMin": 82,
    "speedMax": 105,
    "tip": "370",
    "material": "graphite",
    "confidence": "MED"
  },
  "fujikura-pro-iron-shaft": {
    "launch": "mid",
    "spin": "mid",
    "weightMin": 80,
    "weightMax": 110,
    "torque": 3.0,
    "speedMin": 82,
    "speedMax": 105,
    "tip": "370",
    "material": "graphite",
    "confidence": "MED"
  },
  "fujikura-mci-iron-shaft": {
    "launch": "mid-low",
    "spin": "mid-low",
    "weightMin": 60,
    "weightMax": 125,
    "torque": 2.7,
    "speedMin": 80,
    "speedMax": 105,
    "tip": "370",
    "material": "graphite",
    "confidence": "HIGH"
  },
  "aerotech-steelfiber-fc70-parallel-iron-shaft-0-370-tip": {
    "launch": "mid-high",
    "spin": "mid",
    "weightMin": 70,
    "weightMax": 80,
    "torque": 2.9,
    "speedMin": 68,
    "speedMax": 90,
    "tip": "370",
    "material": "composite",
    "confidence": "MED"
  },
  "aerotech-steelfiber-fc80-parallel-iron-shaft-0-370-tip": {
    "launch": "mid-high",
    "spin": "mid",
    "weightMin": 78,
    "weightMax": 86,
    "torque": 2.7,
    "speedMin": 72,
    "speedMax": 92,
    "tip": "370",
    "material": "composite",
    "confidence": "MED"
  },
  "ust-recoil-460-esx-iron-shaft": {
    "launch": "high",
    "spin": "mid-high",
    "weightMin": 46,
    "weightMax": 65,
    "torque": 4.5,
    "speedMin": 55,
    "speedMax": 80,
    "tip": "370",
    "material": "graphite",
    "confidence": "HIGH"
  },
  "ust-recoil-zt9-iron-shaft": {
    "launch": "mid",
    "spin": "mid",
    "weightMin": 88,
    "weightMax": 110,
    "torque": 3.0,
    "speedMin": 80,
    "speedMax": 102,
    "tip": "370",
    "material": "graphite",
    "confidence": "MED"
  },
  "apollo-stepless-steel-iron-shaft-r-s-combo-flex": {
    "launch": "mid-low",
    "spin": "mid-low",
    "weightMin": 115,
    "weightMax": 125,
    "torque": 1.8,
    "speedMin": 92,
    "speedMax": 112,
    "tip": "370",
    "material": "steel",
    "confidence": "MED"
  },
  "aerotech-steelfiber-fc115-iron-shaft-tapered-355-tip": {
    "launch": "mid",
    "spin": "mid-low",
    "weightMin": 110,
    "weightMax": 120,
    "torque": 2.2,
    "speedMin": 90,
    "speedMax": 110,
    "tip": "355",
    "material": "composite",
    "confidence": "MED"
  },
  "aerotech-steelfiber-fc115-iron-shaft-parallel-370-tip": {
    "launch": "mid",
    "spin": "mid-low",
    "weightMin": 110,
    "weightMax": 120,
    "torque": 2.2,
    "speedMin": 90,
    "speedMax": 110,
    "tip": "370",
    "material": "composite",
    "confidence": "MED"
  },
  "aerotech-steelfiber-fc90-iron-shaft-tapered-355-tip": {
    "launch": "mid-high",
    "spin": "mid",
    "weightMin": 85,
    "weightMax": 95,
    "torque": 2.6,
    "speedMin": 75,
    "speedMax": 96,
    "tip": "355",
    "material": "composite",
    "confidence": "HIGH"
  },
  "aerotech-steelfiber-fc90-iron-shaft-parallel-370-tip": {
    "launch": "mid-high",
    "spin": "mid",
    "weightMin": 85,
    "weightMax": 95,
    "torque": 2.6,
    "speedMin": 75,
    "speedMax": 96,
    "tip": "370",
    "material": "composite",
    "confidence": "HIGH"
  },
  "bundles-set-of-7x-nippon-n-s-pro-modus3-tour120-steel-shaft-4-pw": {
    "launch": "mid-low",
    "spin": "mid",
    "weightMin": 106,
    "weightMax": 120,
    "torque": 1.8,
    "speedMin": 95,
    "speedMax": 112,
    "tip": "355",
    "material": "steel",
    "confidence": "HIGH"
  },
  "bundle-set-of-8x-nippon-n-s-pro-zelos-6-steel-shafts": {
    "launch": "high",
    "spin": "mid-high",
    "weightMin": 68,
    "weightMax": 75,
    "torque": 2.6,
    "speedMin": 60,
    "speedMax": 84,
    "tip": "355",
    "material": "steel",
    "confidence": "HIGH"
  },
  "nippon-n-s-pro-zelos-6-steel-shaft": {
    "launch": "high",
    "spin": "mid-high",
    "weightMin": 68,
    "weightMax": 75,
    "torque": 2.6,
    "speedMin": 60,
    "speedMax": 84,
    "tip": "370",
    "material": "steel",
    "confidence": "HIGH"
  },
  "true-temper-amt-white-steel-shaft": {
    "launch": "low",
    "spin": "mid-low",
    "weightMin": 110,
    "weightMax": 130,
    "torque": 1.8,
    "speedMin": 95,
    "speedMax": 116,
    "tip": "355",
    "material": "steel",
    "confidence": "HIGH"
  },
  "true-temper-amt-black-steel-shaft": {
    "launch": "mid",
    "spin": "mid",
    "weightMin": 95,
    "weightMax": 115,
    "torque": 1.9,
    "speedMin": 88,
    "speedMax": 108,
    "tip": "355",
    "material": "steel",
    "confidence": "HIGH"
  },
  "true-temper-amt-red-steel-shaft": {
    "launch": "mid",
    "spin": "mid",
    "weightMin": 115,
    "weightMax": 125,
    "torque": 1.8,
    "speedMin": 90,
    "speedMax": 112,
    "tip": "355",
    "material": "steel",
    "confidence": "MED"
  },
  "true-temper-dynamic-gold-120-iron-steel-shaft": {
    "launch": "low",
    "spin": "low",
    "weightMin": 118,
    "weightMax": 125,
    "torque": 1.7,
    "speedMin": 92,
    "speedMax": 114,
    "tip": "355",
    "material": "steel",
    "confidence": "HIGH"
  },
  "true-temper-dynamic-gold-115-iron-steel-shaft-tapered-tip": {
    "launch": "mid-low",
    "spin": "mid-low",
    "weightMin": 103,
    "weightMax": 108,
    "torque": 1.8,
    "speedMin": 85,
    "speedMax": 106,
    "tip": "355",
    "material": "steel",
    "confidence": "HIGH"
  },
  "true-temper-dynamic-gold-105-iron-steel-shaft-0-370-parallel-tip": {
    "launch": "mid-low",
    "spin": "mid-low",
    "weightMin": 103,
    "weightMax": 108,
    "torque": 1.8,
    "speedMin": 85,
    "speedMax": 106,
    "tip": "370",
    "material": "steel",
    "confidence": "HIGH"
  },
  "true-temper-dynamic-gold-105-iron-steel-shaft-tapered-tip": {
    "launch": "mid-low",
    "spin": "mid-low",
    "weightMin": 103,
    "weightMax": 108,
    "torque": 1.8,
    "speedMin": 85,
    "speedMax": 106,
    "tip": "355",
    "material": "steel",
    "confidence": "HIGH"
  },
  "new-ust-recoil-660-smoked-chrome-sc-iron-shaft": {
    "launch": "mid-high",
    "spin": "mid",
    "weightMin": 65,
    "weightMax": 72,
    "torque": 3.6,
    "speedMin": 70,
    "speedMax": 90,
    "tip": "370",
    "material": "graphite",
    "confidence": "HIGH"
  },
  "new-ust-recoil-680-smoked-chrome-sc-iron-shaft": {
    "launch": "mid-high",
    "spin": "mid",
    "weightMin": 65,
    "weightMax": 72,
    "torque": 3.6,
    "speedMin": 70,
    "speedMax": 90,
    "tip": "370",
    "material": "graphite",
    "confidence": "HIGH"
  },
  "ust-recoil-780-es-smacwrap-iron-shaft-0-370-parallel-tip": {
    "launch": "mid-high",
    "spin": "mid",
    "weightMin": 75,
    "weightMax": 82,
    "torque": 3.3,
    "speedMin": 75,
    "speedMax": 95,
    "tip": "370",
    "material": "graphite",
    "confidence": "HIGH"
  },
  "ust-recoil-760-es-smacwrap-iron-shaft-0-370-parallel-tip": {
    "launch": "mid-high",
    "spin": "mid",
    "weightMin": 75,
    "weightMax": 82,
    "torque": 3.3,
    "speedMin": 75,
    "speedMax": 95,
    "tip": "370",
    "material": "graphite",
    "confidence": "HIGH"
  },
  "new-ust-recoil-80-iron-shaft-0-355-tapered-tip": {
    "launch": "mid",
    "spin": "mid",
    "weightMin": 78,
    "weightMax": 85,
    "torque": 3.2,
    "speedMin": 75,
    "speedMax": 92,
    "tip": "355",
    "material": "graphite",
    "confidence": "MED"
  },
  "project-x-steel-shaft-370-tip": {
    "launch": "mid",
    "spin": "mid",
    "weightMin": 115,
    "weightMax": 125,
    "torque": 1.8,
    "speedMin": 90,
    "speedMax": 112,
    "tip": "370",
    "material": "steel",
    "confidence": "MED"
  },
  "kbs-tour-tgi-tour-graphite-iron-shaft": {
    "launch": "low",
    "spin": "low",
    "weightMin": 60,
    "weightMax": 110,
    "torque": 2.0,
    "speedMin": 57,
    "speedMax": 100,
    "tip": "370",
    "material": "graphite",
    "confidence": "HIGH"
  },
  "aldila-nv-pink-l-flex-iron-shaft-0-370-tip": {
    "launch": "mid",
    "spin": "mid",
    "weightMin": 95,
    "weightMax": 115,
    "torque": 2.5,
    "speedMin": 82,
    "speedMax": 105,
    "tip": "370",
    "material": "graphite",
    "confidence": "LOW"
  },
  "aldila-nv-pro-105-iron-shaft-0-370-tip": {
    "launch": "mid",
    "spin": "mid",
    "weightMin": 95,
    "weightMax": 115,
    "torque": 2.5,
    "speedMin": 82,
    "speedMax": 105,
    "tip": "370",
    "material": "graphite",
    "confidence": "LOW"
  },
  "aldila-nv-comp-85-iron-shaft-0-370-tip": {
    "launch": "mid",
    "spin": "mid",
    "weightMin": 95,
    "weightMax": 115,
    "torque": 2.5,
    "speedMin": 82,
    "speedMax": 105,
    "tip": "370",
    "material": "graphite",
    "confidence": "LOW"
  },
  "kbs-max-80-shaft-370-tip": {
    "launch": "high",
    "spin": "high",
    "weightMin": 45,
    "weightMax": 85,
    "torque": 3.4,
    "speedMin": 51,
    "speedMax": 82,
    "tip": "370",
    "material": "steel",
    "confidence": "HIGH"
  },
  "bundle-set-of-8x-nippon-n-s-pro-zelos-8-steel-shafts": {
    "launch": "mid-high",
    "spin": "mid",
    "weightMin": 80,
    "weightMax": 87,
    "torque": 2.4,
    "speedMin": 75,
    "speedMax": 94,
    "tip": "355",
    "material": "steel",
    "confidence": "MED"
  },
  "bundle-set-of-8x-nippon-n-s-pro-zelos-7-steel-shafts": {
    "launch": "high",
    "spin": "mid-high",
    "weightMin": 70,
    "weightMax": 77,
    "torque": 2.5,
    "speedMin": 65,
    "speedMax": 88,
    "tip": "355",
    "material": "steel",
    "confidence": "HIGH"
  },
  "bundle-set-of-8x-true-temper-xp-95-steel-shafts": {
    "launch": "mid",
    "spin": "mid",
    "weightMin": 95,
    "weightMax": 100,
    "torque": 2.0,
    "speedMin": 80,
    "speedMax": 98,
    "tip": "355",
    "material": "steel",
    "confidence": "HIGH"
  },
  "kbs-tour-105-shaft-370-tip": {
    "launch": "mid-high",
    "spin": "high",
    "weightMin": 105,
    "weightMax": 115,
    "torque": 1.8,
    "speedMin": 88,
    "speedMax": 106,
    "tip": "370",
    "material": "steel",
    "confidence": "HIGH"
  },
  "true-temper-dynamic-gold-iron-with-sensicore-steel-shaft-tapered-tip": {
    "launch": "low",
    "spin": "low",
    "weightMin": 128,
    "weightMax": 132,
    "torque": 1.8,
    "speedMin": 95,
    "speedMax": 116,
    "tip": "355",
    "material": "steel",
    "confidence": "HIGH"
  },
  "kbs-tour-taper-shaft-black-pvd": {
    "launch": "mid-low",
    "spin": "mid-low",
    "weightMin": 115,
    "weightMax": 130,
    "torque": 1.7,
    "speedMin": 95,
    "speedMax": 113,
    "tip": "355",
    "material": "steel",
    "confidence": "HIGH"
  },
  "project-x-lz-steel-shaft": {
    "launch": "mid",
    "spin": "mid",
    "weightMin": 115,
    "weightMax": 125,
    "torque": 1.8,
    "speedMin": 92,
    "speedMax": 112,
    "tip": "355",
    "material": "steel",
    "confidence": "HIGH"
  },
  "bundle-set-of-8x-kbs-tour-130-shafts": {
    "launch": "low-mid",
    "spin": "low",
    "weightMin": 130,
    "weightMax": 135,
    "torque": 1.6,
    "speedMin": 100,
    "speedMax": 118,
    "tip": "355",
    "material": "steel",
    "confidence": "MED"
  },
  "bundle-set-of-8x-kbs-tour-110-shafts": {
    "launch": "mid",
    "spin": "mid",
    "weightMin": 108,
    "weightMax": 116,
    "torque": 1.75,
    "speedMin": 90,
    "speedMax": 110,
    "tip": "355",
    "material": "steel",
    "confidence": "MED"
  },
  "bundle-set-of-8x-kbs-tour-120-shafts": {
    "launch": "mid",
    "spin": "mid",
    "weightMin": 118,
    "weightMax": 125,
    "torque": 1.7,
    "speedMin": 95,
    "speedMax": 114,
    "tip": "370",
    "material": "steel",
    "confidence": "MED"
  },
  "bundle-set-of-8x-kbs-tour-105-shafts": {
    "launch": "mid-high",
    "spin": "high",
    "weightMin": 105,
    "weightMax": 115,
    "torque": 1.8,
    "speedMin": 88,
    "speedMax": 106,
    "tip": "355",
    "material": "steel",
    "confidence": "HIGH"
  },
  "bundle-set-of-8x-kbs-tour-90-shaft": {
    "launch": "mid",
    "spin": "mid",
    "weightMin": 110,
    "weightMax": 130,
    "torque": 1.7,
    "speedMin": 90,
    "speedMax": 112,
    "tip": "355",
    "material": "steel",
    "confidence": "MED"
  },
  "bundle-set-of-8x-kbs-c-taper-lite-shafts": {
    "launch": "mid-low",
    "spin": "mid-low",
    "weightMin": 105,
    "weightMax": 115,
    "torque": 1.9,
    "speedMin": 88,
    "speedMax": 107,
    "tip": "355",
    "material": "steel",
    "confidence": "HIGH"
  },
  "set-of-8x-kbs-tour-c-taper-shafts": {
    "launch": "low",
    "spin": "low",
    "weightMin": 113,
    "weightMax": 130,
    "torque": 1.7,
    "speedMin": 95,
    "speedMax": 116,
    "tip": "355",
    "material": "steel",
    "confidence": "HIGH"
  },
  "kbs-tour-130-steel-shaft-355-taper-tip": {
    "launch": "low-mid",
    "spin": "low",
    "weightMin": 130,
    "weightMax": 135,
    "torque": 1.6,
    "speedMin": 100,
    "speedMax": 118,
    "tip": "355",
    "material": "steel",
    "confidence": "MED"
  },
  "kbs-tour-125-steel-shaft-355-taper-tip": {
    "launch": "mid-low",
    "spin": "mid-low",
    "weightMin": 123,
    "weightMax": 130,
    "torque": 1.65,
    "speedMin": 98,
    "speedMax": 116,
    "tip": "355",
    "material": "steel",
    "confidence": "MED"
  },
  "kbs-tour-115-steel-shaft-355-taper-tip": {
    "launch": "mid",
    "spin": "mid",
    "weightMin": 108,
    "weightMax": 116,
    "torque": 1.75,
    "speedMin": 90,
    "speedMax": 110,
    "tip": "355",
    "material": "steel",
    "confidence": "MED"
  },
  "kbs-tour-110-steel-shaft-355-taper-tip": {
    "launch": "mid",
    "spin": "mid",
    "weightMin": 108,
    "weightMax": 116,
    "torque": 1.75,
    "speedMin": 90,
    "speedMax": 110,
    "tip": "355",
    "material": "steel",
    "confidence": "MED"
  },
  "kbs-tour-taper-shaft": {
    "launch": "mid-low",
    "spin": "mid-low",
    "weightMin": 115,
    "weightMax": 130,
    "torque": 1.7,
    "speedMin": 95,
    "speedMax": 113,
    "tip": "355",
    "material": "steel",
    "confidence": "HIGH"
  },
  "kbs-tour-flt-shaft-black-matte": {
    "launch": "mid",
    "spin": "mid",
    "weightMin": 110,
    "weightMax": 120,
    "torque": 1.75,
    "speedMin": 90,
    "speedMax": 108,
    "tip": "355",
    "material": "steel",
    "confidence": "MED"
  },
  "kbs-tour-flt-shaft": {
    "launch": "mid",
    "spin": "mid",
    "weightMin": 110,
    "weightMax": 120,
    "torque": 1.75,
    "speedMin": 90,
    "speedMax": 108,
    "tip": "355",
    "material": "steel",
    "confidence": "MED"
  },
  "nippon-n-s-pro-zelos-8-steel-shaft": {
    "launch": "mid-high",
    "spin": "mid",
    "weightMin": 80,
    "weightMax": 87,
    "torque": 2.4,
    "speedMin": 75,
    "speedMax": 94,
    "tip": "370",
    "material": "steel",
    "confidence": "MED"
  },
  "nippon-n-s-pro-zelos-7-steel-shaft": {
    "launch": "high",
    "spin": "mid-high",
    "weightMin": 70,
    "weightMax": 77,
    "torque": 2.5,
    "speedMin": 65,
    "speedMax": 88,
    "tip": "370",
    "material": "steel",
    "confidence": "HIGH"
  },
  "true-temper-dynamic-gold-amt-s300-steel-shaft": {
    "launch": "mid",
    "spin": "mid",
    "weightMin": 100,
    "weightMax": 120,
    "torque": 1.9,
    "speedMin": 88,
    "speedMax": 110,
    "tip": "355",
    "material": "steel",
    "confidence": "MED"
  },
  "kbs-tour-custom-series-steel-shaft-taper-tip": {
    "launch": "mid",
    "spin": "mid",
    "weightMin": 110,
    "weightMax": 130,
    "torque": 1.7,
    "speedMin": 90,
    "speedMax": 112,
    "tip": "355",
    "material": "steel",
    "confidence": "MED"
  },
  "ust-recoil-110-tapered-iron-shaft": {
    "launch": "mid",
    "spin": "mid",
    "weightMin": 105,
    "weightMax": 115,
    "torque": 2.8,
    "speedMin": 85,
    "speedMax": 105,
    "tip": "355",
    "material": "graphite",
    "confidence": "HIGH"
  },
  "ust-recoil-95-tapered-iron-shaft": {
    "launch": "mid",
    "spin": "mid",
    "weightMin": 88,
    "weightMax": 99,
    "torque": 3.0,
    "speedMin": 80,
    "speedMax": 98,
    "tip": "355",
    "material": "graphite",
    "confidence": "HIGH"
  },
  "ust-recoil-680-iron-shaft": {
    "launch": "mid-high",
    "spin": "mid",
    "weightMin": 65,
    "weightMax": 72,
    "torque": 3.6,
    "speedMin": 70,
    "speedMax": 90,
    "tip": "370",
    "material": "graphite",
    "confidence": "HIGH"
  },
  "kbs-tour-black-nickel-steel-shaft-taper-tip": {
    "launch": "mid",
    "spin": "mid",
    "weightMin": 110,
    "weightMax": 130,
    "torque": 1.7,
    "speedMin": 90,
    "speedMax": 112,
    "tip": "355",
    "material": "steel",
    "confidence": "MED"
  },
  "kbs-580-shaft-tapered-tip": {
    "launch": "high",
    "spin": "high",
    "weightMin": 55,
    "weightMax": 65,
    "torque": 3.6,
    "speedMin": 50,
    "speedMax": 78,
    "tip": "355",
    "material": "steel",
    "confidence": "MED"
  },
  "kbs-560-shaft-tapered-tip": {
    "launch": "high",
    "spin": "high",
    "weightMin": 55,
    "weightMax": 65,
    "torque": 3.6,
    "speedMin": 50,
    "speedMax": 78,
    "tip": "355",
    "material": "steel",
    "confidence": "MED"
  },
  "graphite-design-tour-ad-95-iron-shaft": {
    "launch": "low",
    "spin": "low",
    "weightMin": 85,
    "weightMax": 95,
    "torque": 2.8,
    "speedMin": 86,
    "speedMax": 110,
    "tip": "355",
    "material": "graphite",
    "confidence": "HIGH"
  },
  "graphite-design-tour-ad-85-iron-shaft": {
    "launch": "low",
    "spin": "low",
    "weightMin": 85,
    "weightMax": 95,
    "torque": 2.8,
    "speedMin": 86,
    "speedMax": 110,
    "tip": "355",
    "material": "graphite",
    "confidence": "HIGH"
  },
  "graphite-design-tour-ad-75-iron-shaft": {
    "launch": "mid",
    "spin": "mid",
    "weightMin": 50,
    "weightMax": 115,
    "torque": 3.0,
    "speedMin": 75,
    "speedMax": 108,
    "tip": "355",
    "material": "graphite",
    "confidence": "HIGH"
  },
  "graphite-design-tour-ad-65-iron-shaft": {
    "launch": "mid",
    "spin": "mid",
    "weightMin": 50,
    "weightMax": 115,
    "torque": 3.0,
    "speedMin": 75,
    "speedMax": 108,
    "tip": "355",
    "material": "graphite",
    "confidence": "HIGH"
  },
  "graphite-design-tour-ad-55-iron-shaft": {
    "launch": "mid",
    "spin": "mid",
    "weightMin": 50,
    "weightMax": 115,
    "torque": 3.0,
    "speedMin": 75,
    "speedMax": 108,
    "tip": "355",
    "material": "graphite",
    "confidence": "HIGH"
  },
  "graphite-design-tour-ad-50-iron-shaft": {
    "launch": "mid",
    "spin": "mid",
    "weightMin": 50,
    "weightMax": 115,
    "torque": 3.0,
    "speedMin": 75,
    "speedMax": 108,
    "tip": "355",
    "material": "graphite",
    "confidence": "HIGH"
  },
  "nippon-n-s-pro-1150gh-steel-shaft-parallel-tip": {
    "launch": "mid-low",
    "spin": "mid-low",
    "weightMin": 110,
    "weightMax": 116,
    "torque": 1.7,
    "speedMin": 95,
    "speedMax": 113,
    "tip": "370",
    "material": "steel",
    "confidence": "MED"
  },
  "nippon-n-s-pro-1150gh-steel-shaft-tapered-tip": {
    "launch": "mid-low",
    "spin": "mid-low",
    "weightMin": 110,
    "weightMax": 116,
    "torque": 1.7,
    "speedMin": 95,
    "speedMax": 113,
    "tip": "355",
    "material": "steel",
    "confidence": "MED"
  },
  "alpha-tour-lite-iron-shaft": {
    "launch": "mid-high",
    "spin": "mid",
    "weightMin": 95,
    "weightMax": 110,
    "torque": 1.9,
    "speedMin": 85,
    "speedMax": 107,
    "tip": "370",
    "material": "graphite",
    "confidence": "MED"
  },
  "nippon-n-s-pro-modus3-tour130": {
    "launch": "mid-high",
    "spin": "low",
    "weightMin": 124,
    "weightMax": 132,
    "torque": 1.4,
    "speedMin": 95,
    "speedMax": 112,
    "tip": "355",
    "material": "steel",
    "confidence": "HIGH"
  },
  "nippon-n-s-pro-modus3-tour125": {
    "launch": "mid",
    "spin": "mid",
    "weightMin": 120,
    "weightMax": 128,
    "torque": 1.5,
    "speedMin": 95,
    "speedMax": 112,
    "tip": "355",
    "material": "steel",
    "confidence": "HIGH"
  },
  "nippon-n-s-pro-modus3-tour120": {
    "launch": "mid-low",
    "spin": "mid",
    "weightMin": 106,
    "weightMax": 120,
    "torque": 1.8,
    "speedMin": 95,
    "speedMax": 112,
    "tip": "355",
    "material": "steel",
    "confidence": "HIGH"
  },
  "nippon-ns-pro-modus3-tour105": {
    "launch": "mid",
    "spin": "mid",
    "weightMin": 103,
    "weightMax": 113,
    "torque": 1.6,
    "speedMin": 90,
    "speedMax": 107,
    "tip": "355",
    "material": "steel",
    "confidence": "HIGH"
  },
  "nippon-n-s-pro-950gh-steel-shaft": {
    "launch": "mid-low",
    "spin": "mid-low",
    "weightMin": 110,
    "weightMax": 116,
    "torque": 1.7,
    "speedMin": 95,
    "speedMax": 113,
    "tip": "355",
    "material": "steel",
    "confidence": "MED"
  },
  "true-temper-dg-pro-iron-steel-shaft": {
    "launch": "low",
    "spin": "low",
    "weightMin": 128,
    "weightMax": 132,
    "torque": 1.8,
    "speedMin": 95,
    "speedMax": 116,
    "tip": "355",
    "material": "steel",
    "confidence": "HIGH"
  },
  "true-temper-xp-95-steel-shaft-parallel-tip": {
    "launch": "mid",
    "spin": "mid",
    "weightMin": 95,
    "weightMax": 100,
    "torque": 2.0,
    "speedMin": 80,
    "speedMax": 98,
    "tip": "370",
    "material": "steel",
    "confidence": "HIGH"
  },
  "true-temper-dynamic-gold-tour-issue-onyx-steel-shaft": {
    "launch": "mid",
    "spin": "mid",
    "weightMin": 120,
    "weightMax": 130,
    "torque": 1.7,
    "speedMin": 90,
    "speedMax": 112,
    "tip": "355",
    "material": "steel",
    "confidence": "MED"
  },
  "kbs-580-shaft": {
    "launch": "high",
    "spin": "high",
    "weightMin": 55,
    "weightMax": 65,
    "torque": 3.6,
    "speedMin": 50,
    "speedMax": 78,
    "tip": "370",
    "material": "steel",
    "confidence": "MED"
  },
  "kbs-560-shaft": {
    "launch": "high",
    "spin": "high",
    "weightMin": 55,
    "weightMax": 65,
    "torque": 3.6,
    "speedMin": 50,
    "speedMax": 78,
    "tip": "370",
    "material": "steel",
    "confidence": "MED"
  },
  "kbs-hi-rev-2-0-wedge-shaft": {
    "launch": "mid",
    "spin": "mid",
    "weightMin": 110,
    "weightMax": 130,
    "torque": 1.7,
    "speedMin": 90,
    "speedMax": 112,
    "tip": "355",
    "material": "steel",
    "confidence": "MED"
  },
  "kbs-wedge-shaft": {
    "launch": "mid",
    "spin": "mid",
    "weightMin": 110,
    "weightMax": 130,
    "torque": 1.7,
    "speedMin": 90,
    "speedMax": 112,
    "tip": "355",
    "material": "steel",
    "confidence": "MED"
  },
  "kbs-tour-v-wedge-shaft": {
    "launch": "mid",
    "spin": "mid",
    "weightMin": 110,
    "weightMax": 125,
    "torque": 1.7,
    "speedMin": 92,
    "speedMax": 112,
    "tip": "355",
    "material": "steel",
    "confidence": "MED"
  },
  "kbs-610-wedge-shaft": {
    "launch": "mid",
    "spin": "mid",
    "weightMin": 110,
    "weightMax": 130,
    "torque": 1.7,
    "speedMin": 90,
    "speedMax": 112,
    "tip": "355",
    "material": "steel",
    "confidence": "MED"
  },
  "kbs-tour-105-steel-shaft": {
    "launch": "mid-high",
    "spin": "high",
    "weightMin": 105,
    "weightMax": 115,
    "torque": 1.8,
    "speedMin": 88,
    "speedMax": 106,
    "tip": "355",
    "material": "steel",
    "confidence": "HIGH"
  },
  "alpha-pt75-tapered-tip-shaft": {
    "launch": "mid",
    "spin": "mid",
    "weightMin": 60,
    "weightMax": 95,
    "torque": 3.2,
    "speedMin": 75,
    "speedMax": 98,
    "tip": "355",
    "material": "graphite",
    "confidence": "LOW"
  },
  "alpha-pt85-tapered-tip-shaft": {
    "launch": "mid",
    "spin": "mid",
    "weightMin": 60,
    "weightMax": 95,
    "torque": 3.2,
    "speedMin": 75,
    "speedMax": 98,
    "tip": "355",
    "material": "graphite",
    "confidence": "LOW"
  },
  "alpha-pt95g-tapered-tip-shaft": {
    "launch": "mid",
    "spin": "mid",
    "weightMin": 60,
    "weightMax": 95,
    "torque": 3.2,
    "speedMin": 75,
    "speedMax": 98,
    "tip": "355",
    "material": "graphite",
    "confidence": "LOW"
  },
  "kbs-c-taper-lite-shaft-parallel-tip": {
    "launch": "mid-low",
    "spin": "mid-low",
    "weightMin": 105,
    "weightMax": 115,
    "torque": 1.9,
    "speedMin": 88,
    "speedMax": 107,
    "tip": "370",
    "material": "steel",
    "confidence": "HIGH"
  },
  "aldila-vs-proto-105-taper-tip-iron-shaft": {
    "launch": "mid",
    "spin": "mid",
    "weightMin": 95,
    "weightMax": 115,
    "torque": 2.5,
    "speedMin": 82,
    "speedMax": 105,
    "tip": "355",
    "material": "graphite",
    "confidence": "LOW"
  },
  "aldila-vs-proto-85-taper-tip-iron-shaft": {
    "launch": "mid",
    "spin": "mid",
    "weightMin": 95,
    "weightMax": 115,
    "torque": 2.5,
    "speedMin": 82,
    "speedMax": 105,
    "tip": "355",
    "material": "graphite",
    "confidence": "LOW"
  },
  "aldila-nv-pro-105-taper-tip-iron-shaft": {
    "launch": "mid",
    "spin": "mid",
    "weightMin": 95,
    "weightMax": 115,
    "torque": 2.5,
    "speedMin": 82,
    "speedMax": 105,
    "tip": "355",
    "material": "graphite",
    "confidence": "LOW"
  },
  "aldila-nv-iron-taper-tip-shaft": {
    "launch": "mid",
    "spin": "mid",
    "weightMin": 95,
    "weightMax": 115,
    "torque": 2.5,
    "speedMin": 82,
    "speedMax": 105,
    "tip": "355",
    "material": "graphite",
    "confidence": "LOW"
  },
  "apollo-junior-iron-shaft": {
    "launch": "mid",
    "spin": "mid",
    "weightMin": 115,
    "weightMax": 130,
    "torque": 1.9,
    "speedMin": 88,
    "speedMax": 110,
    "tip": "370",
    "material": "steel",
    "confidence": "LOW"
  },
  "platinum-iron-shaft": {
    "launch": "mid",
    "spin": "mid",
    "weightMin": 60,
    "weightMax": 95,
    "torque": 3.2,
    "speedMin": 75,
    "speedMax": 98,
    "tip": "370",
    "material": "graphite",
    "confidence": "LOW"
  },
  "true-temper-dynamic-gold-tour-issue-steel-shaft": {
    "launch": "low",
    "spin": "low",
    "weightMin": 128,
    "weightMax": 132,
    "torque": 1.6,
    "speedMin": 95,
    "speedMax": 118,
    "tip": "355",
    "material": "steel",
    "confidence": "HIGH"
  },
  "ust-recoil-tapered-iron-shaft": {
    "launch": "mid",
    "spin": "mid",
    "weightMin": 88,
    "weightMax": 110,
    "torque": 3.0,
    "speedMin": 80,
    "speedMax": 102,
    "tip": "355",
    "material": "graphite",
    "confidence": "MED"
  },
  "ust-mp6-iron-shaft": {
    "launch": "mid-high",
    "spin": "mid",
    "weightMin": 60,
    "weightMax": 80,
    "torque": 3.5,
    "speedMin": 70,
    "speedMax": 92,
    "tip": "370",
    "material": "graphite",
    "confidence": "MED"
  },
  "project-x-5-5-taper-tip-steel-shaft": {
    "launch": "mid",
    "spin": "mid",
    "weightMin": 115,
    "weightMax": 125,
    "torque": 1.8,
    "speedMin": 90,
    "speedMax": 112,
    "tip": "355",
    "material": "steel",
    "confidence": "MED"
  },
  "project-x-95-flighted-steel-shaft": {
    "launch": "mid",
    "spin": "mid",
    "weightMin": 115,
    "weightMax": 125,
    "torque": 1.8,
    "speedMin": 90,
    "speedMax": 112,
    "tip": "355",
    "material": "steel",
    "confidence": "MED"
  },
  "kbs-tour-v-shaft": {
    "launch": "mid",
    "spin": "mid",
    "weightMin": 110,
    "weightMax": 125,
    "torque": 1.7,
    "speedMin": 92,
    "speedMax": 112,
    "tip": "355",
    "material": "steel",
    "confidence": "MED"
  },
  "kbs-tour-120-shaft-taper-tip": {
    "launch": "mid",
    "spin": "mid",
    "weightMin": 118,
    "weightMax": 125,
    "torque": 1.7,
    "speedMin": 95,
    "speedMax": 114,
    "tip": "355",
    "material": "steel",
    "confidence": "MED"
  },
  "kbs-tour-steel-shaft-parallel-tip": {
    "launch": "mid",
    "spin": "mid",
    "weightMin": 118,
    "weightMax": 125,
    "torque": 1.7,
    "speedMin": 95,
    "speedMax": 114,
    "tip": "370",
    "material": "steel",
    "confidence": "MED"
  },
  "kbs-tour-c-taper-taper-tip-steel-shaft": {
    "launch": "low",
    "spin": "low",
    "weightMin": 113,
    "weightMax": 130,
    "torque": 1.7,
    "speedMin": 95,
    "speedMax": 116,
    "tip": "355",
    "material": "steel",
    "confidence": "HIGH"
  },
  "kbs-tour-c-taper-steel-shaft-parallel-tip": {
    "launch": "low",
    "spin": "low",
    "weightMin": 113,
    "weightMax": 130,
    "torque": 1.7,
    "speedMin": 95,
    "speedMax": 116,
    "tip": "370",
    "material": "steel",
    "confidence": "HIGH"
  },
  "kbs-tour-90-steel-shafts": {
    "launch": "mid",
    "spin": "mid",
    "weightMin": 110,
    "weightMax": 130,
    "torque": 1.7,
    "speedMin": 90,
    "speedMax": 112,
    "tip": "355",
    "material": "steel",
    "confidence": "MED"
  },
  "kbs-tour-90-steel-shafts-parallel-tip": {
    "launch": "mid",
    "spin": "mid",
    "weightMin": 110,
    "weightMax": 130,
    "torque": 1.7,
    "speedMin": 90,
    "speedMax": 112,
    "tip": "370",
    "material": "steel",
    "confidence": "MED"
  },
  "kbs-c-taper-lite-shaft": {
    "launch": "mid-low",
    "spin": "mid-low",
    "weightMin": 105,
    "weightMax": 115,
    "torque": 1.9,
    "speedMin": 88,
    "speedMax": 107,
    "tip": "355",
    "material": "steel",
    "confidence": "HIGH"
  },
  "aldila-vs-proto-iron-shaft": {
    "launch": "mid",
    "spin": "mid",
    "weightMin": 95,
    "weightMax": 115,
    "torque": 2.5,
    "speedMin": 82,
    "speedMax": 105,
    "tip": "370",
    "material": "graphite",
    "confidence": "LOW"
  },
  "aerotech-steelfiber-iron-shaft": {
    "launch": "mid-low",
    "spin": "low",
    "weightMin": 105,
    "weightMax": 115,
    "torque": 2.2,
    "speedMin": 90,
    "speedMax": 112,
    "tip": "370",
    "material": "composite",
    "confidence": "HIGH"
  },
  "true-temper-xp-95-steel-shaft": {
    "launch": "mid",
    "spin": "mid",
    "weightMin": 95,
    "weightMax": 100,
    "torque": 2.0,
    "speedMin": 80,
    "speedMax": 98,
    "tip": "355",
    "material": "steel",
    "confidence": "HIGH"
  },
  "true-temper-tt-lite-xl-tapered-iron-steel-shaft": {
    "launch": "mid-high",
    "spin": "mid",
    "weightMin": 80,
    "weightMax": 95,
    "torque": 2.4,
    "speedMin": 75,
    "speedMax": 95,
    "tip": "355",
    "material": "steel",
    "confidence": "MED"
  },
  "true-temper-tt-lite-xl-parallel-iron-steel-shaft": {
    "launch": "mid-high",
    "spin": "mid",
    "weightMin": 80,
    "weightMax": 95,
    "torque": 2.4,
    "speedMin": 75,
    "speedMax": 95,
    "tip": "370",
    "material": "steel",
    "confidence": "MED"
  },
  "true-temper-multi-step-lite-parallel-iron-steel-shaft": {
    "launch": "mid",
    "spin": "mid",
    "weightMin": 95,
    "weightMax": 110,
    "torque": 2.0,
    "speedMin": 82,
    "speedMax": 102,
    "tip": "370",
    "material": "steel",
    "confidence": "MED"
  },
  "true-temper-dynamic-gold-tapered-iron-shaft-355t": {
    "launch": "low",
    "spin": "low",
    "weightMin": 128,
    "weightMax": 132,
    "torque": 1.8,
    "speedMin": 95,
    "speedMax": 116,
    "tip": "355",
    "material": "steel",
    "confidence": "HIGH"
  },
  "true-temper-dynamic-gold-sl-tapered-iron-steel-shaft": {
    "launch": "low",
    "spin": "mid-low",
    "weightMin": 104,
    "weightMax": 108,
    "torque": 1.9,
    "speedMin": 85,
    "speedMax": 105,
    "tip": "355",
    "material": "steel",
    "confidence": "HIGH"
  },
  "true-temper-dynamic-gold-sl-parallel-iron-shaft-370": {
    "launch": "low",
    "spin": "mid-low",
    "weightMin": 104,
    "weightMax": 108,
    "torque": 1.9,
    "speedMin": 85,
    "speedMax": 105,
    "tip": "370",
    "material": "steel",
    "confidence": "HIGH"
  },
  "true-temper-dynamic-gold-parallel-iron-shaft-370": {
    "launch": "low",
    "spin": "low",
    "weightMin": 128,
    "weightMax": 132,
    "torque": 1.8,
    "speedMin": 95,
    "speedMax": 116,
    "tip": "370",
    "material": "steel",
    "confidence": "HIGH"
  },
  "fst-steel-shaft-90-115-125": {
    "launch": "mid",
    "spin": "mid",
    "weightMin": 90,
    "weightMax": 125,
    "torque": 1.9,
    "speedMin": 82,
    "speedMax": 112,
    "tip": "370",
    "material": "steel",
    "confidence": "LOW"
  },
  "fst-pro-stepless-steel-iron-shaft-115-125": {
    "launch": "mid-low",
    "spin": "mid-low",
    "weightMin": 115,
    "weightMax": 125,
    "torque": 1.8,
    "speedMin": 92,
    "speedMax": 112,
    "tip": "370",
    "material": "steel",
    "confidence": "MED"
  },
  "apollo-standard-steel-shaft": {
    "launch": "mid",
    "spin": "mid",
    "weightMin": 115,
    "weightMax": 130,
    "torque": 1.9,
    "speedMin": 88,
    "speedMax": 110,
    "tip": "370",
    "material": "steel",
    "confidence": "LOW"
  },
  "ust-dhi-series-irn-iron-shaft": {
    "launch": "mid",
    "spin": "mid",
    "weightMin": 95,
    "weightMax": 115,
    "torque": 2.8,
    "speedMin": 82,
    "speedMax": 105,
    "tip": "370",
    "material": "steel",
    "confidence": "LOW"
  },
  "ust-competition-series-iron-shaft": {
    "launch": "mid",
    "spin": "mid",
    "weightMin": 95,
    "weightMax": 115,
    "torque": 2.5,
    "speedMin": 82,
    "speedMax": 105,
    "tip": "370",
    "material": "graphite",
    "confidence": "LOW"
  },
  "grafalloy-pro-custom-graphite-iron-shaft": {
    "launch": "mid-high",
    "spin": "mid",
    "weightMin": 70,
    "weightMax": 90,
    "torque": 3.3,
    "speedMin": 72,
    "speedMax": 95,
    "tip": "370",
    "material": "graphite",
    "confidence": "LOW"
  },
  "kbs-generation-jr-graphite-iron-shaft-370-parallel-tip": {
    "launch": "high",
    "spin": "high",
    "weightMin": 55,
    "weightMax": 70,
    "torque": 3.8,
    "speedMin": 50,
    "speedMax": 78,
    "tip": "370",
    "material": "graphite",
    "confidence": "MED"
  },
  "true-temper-vector-steel-iron-shaft-0-370-tip": {
    "launch": "mid",
    "spin": "mid",
    "weightMin": 95,
    "weightMax": 110,
    "torque": 2.2,
    "speedMin": 82,
    "speedMax": 102,
    "tip": "370",
    "material": "steel",
    "confidence": "LOW"
  },
  "project-x-cypher-2-0-shaft-370-tip": {
    "launch": "high",
    "spin": "high",
    "weightMin": 50,
    "weightMax": 70,
    "torque": 4.5,
    "speedMin": 55,
    "speedMax": 82,
    "tip": "370",
    "material": "graphite",
    "confidence": "MED"
  },
  "true-temper-custom-lite-step-pattern-shaft-with-sensicore-0-370-tip-no-label": {
    "launch": "mid",
    "spin": "mid",
    "weightMin": 95,
    "weightMax": 110,
    "torque": 2.2,
    "speedMin": 82,
    "speedMax": 102,
    "tip": "370",
    "material": "steel",
    "confidence": "LOW"
  },
  "new-mitsubishi-c6-black-iron-22-shaft": {
    "launch": "mid-high",
    "spin": "mid",
    "weightMin": 55,
    "weightMax": 80,
    "torque": 3.5,
    "speedMin": 70,
    "speedMax": 95,
    "tip": "370",
    "material": "graphite",
    "confidence": "MED"
  },
  "project-x-cypher-shaft-370-tip": {
    "launch": "high",
    "spin": "high",
    "weightMin": 50,
    "weightMax": 70,
    "torque": 4.5,
    "speedMin": 55,
    "speedMax": 82,
    "tip": "370",
    "material": "graphite",
    "confidence": "MED"
  },
  "aerotech-players-spec-iron-shaft": {
    "launch": "mid",
    "spin": "mid-low",
    "weightMin": 90,
    "weightMax": 98,
    "torque": 2.5,
    "speedMin": 80,
    "speedMax": 100,
    "tip": "370",
    "material": "steel",
    "confidence": "MED"
  },
  "aerotech-players-spec-iron-tapered-shaft": {
    "launch": "mid",
    "spin": "mid-low",
    "weightMin": 90,
    "weightMax": 98,
    "torque": 2.5,
    "speedMin": 80,
    "speedMax": 100,
    "tip": "355",
    "material": "steel",
    "confidence": "MED"
  },
  "graphite-design-g-series-iron-shafts": {
    "launch": "mid",
    "spin": "mid",
    "weightMin": 60,
    "weightMax": 90,
    "torque": 3.2,
    "speedMin": 72,
    "speedMax": 98,
    "tip": "370",
    "material": "graphite",
    "confidence": "LOW"
  },
  "mitsubishi-c6-black-hybrid-iron-shaft-assembled-tip-grip": {
    "launch": "mid-high",
    "spin": "mid",
    "weightMin": 55,
    "weightMax": 80,
    "torque": 3.5,
    "speedMin": 70,
    "speedMax": 95,
    "tip": "370",
    "material": "graphite",
    "confidence": "MED"
  },
  "mitsubishi-tensei-av-red-am2-iron-shaft-0-355-taper-tip": {
    "launch": "mid",
    "spin": "mid",
    "weightMin": 55,
    "weightMax": 80,
    "torque": 3.3,
    "speedMin": 72,
    "speedMax": 98,
    "tip": "355",
    "material": "graphite",
    "confidence": "MED"
  },
  "mitsubishi-tensei-av-white-am2-iron-shaft-0-355-taper-tip": {
    "launch": "mid",
    "spin": "mid",
    "weightMin": 55,
    "weightMax": 80,
    "torque": 3.3,
    "speedMin": 72,
    "speedMax": 98,
    "tip": "355",
    "material": "graphite",
    "confidence": "MED"
  },
  "mitsubishi-c6-black-hybrid-iron-shaft": {
    "launch": "mid-high",
    "spin": "mid",
    "weightMin": 55,
    "weightMax": 80,
    "torque": 3.5,
    "speedMin": 70,
    "speedMax": 95,
    "tip": "370",
    "material": "graphite",
    "confidence": "MED"
  },
  "mitsubishi-tensei-av-blue-am2-series-iron-shaft": {
    "launch": "mid",
    "spin": "mid",
    "weightMin": 55,
    "weightMax": 80,
    "torque": 3.3,
    "speedMin": 72,
    "speedMax": 98,
    "tip": "355",
    "material": "graphite",
    "confidence": "MED"
  },
  "true-temper-binary-iron-shaft-with-vss-shaft-0-370-taper-tip": {
    "launch": "mid",
    "spin": "mid",
    "weightMin": 95,
    "weightMax": 115,
    "torque": 2.2,
    "speedMin": 82,
    "speedMax": 105,
    "tip": "370",
    "material": "steel",
    "confidence": "LOW"
  },
  "true-temper-binary-iron-shaft-with-vss-shaft-0-355-taper-tip": {
    "launch": "mid",
    "spin": "mid",
    "weightMin": 95,
    "weightMax": 115,
    "torque": 2.2,
    "speedMin": 82,
    "speedMax": 105,
    "tip": "355",
    "material": "steel",
    "confidence": "LOW"
  },
  "mitsubishi-grand-bassara-iron-shaft": {
    "launch": "high",
    "spin": "mid-high",
    "weightMin": 45,
    "weightMax": 65,
    "torque": 4.5,
    "speedMin": 55,
    "speedMax": 82,
    "tip": "370",
    "material": "graphite",
    "confidence": "MED"
  },
  "true-temper-xp-100-steel-shaft": {
    "launch": "mid",
    "spin": "mid",
    "weightMin": 98,
    "weightMax": 103,
    "torque": 2.0,
    "speedMin": 82,
    "speedMax": 102,
    "tip": "370",
    "material": "steel",
    "confidence": "HIGH"
  },
  "mitsubishi-bassara-e-series-hybrid-iron-shaft": {
    "launch": "high",
    "spin": "mid-high",
    "weightMin": 45,
    "weightMax": 65,
    "torque": 4.5,
    "speedMin": 55,
    "speedMax": 82,
    "tip": "370",
    "material": "graphite",
    "confidence": "MED"
  },
  "mitsubishi-kuro-kage-iron-shaft": {
    "launch": "mid-high",
    "spin": "mid",
    "weightMin": 60,
    "weightMax": 85,
    "torque": 3.5,
    "speedMin": 70,
    "speedMax": 95,
    "tip": "370",
    "material": "graphite",
    "confidence": "MED"
  },
  "true-temper-xp-115-steel-shaft": {
    "launch": "mid",
    "spin": "mid-low",
    "weightMin": 110,
    "weightMax": 118,
    "torque": 1.9,
    "speedMin": 90,
    "speedMax": 108,
    "tip": "355",
    "material": "steel",
    "confidence": "HIGH"
  },
  "luxe-lx-iron-shaft": {
    "launch": "mid",
    "spin": "mid",
    "weightMin": 60,
    "weightMax": 90,
    "torque": 3.2,
    "speedMin": 72,
    "speedMax": 98,
    "tip": "370",
    "material": "graphite",
    "confidence": "LOW"
  },
  "graphite-design-g-tech-iron-shaft": {
    "launch": "mid",
    "spin": "mid",
    "weightMin": 60,
    "weightMax": 90,
    "torque": 3.2,
    "speedMin": 72,
    "speedMax": 98,
    "tip": "370",
    "material": "graphite",
    "confidence": "LOW"
  },
  "project-x-pxi-steel-shaft": {
    "launch": "mid-low",
    "spin": "mid",
    "weightMin": 105,
    "weightMax": 115,
    "torque": 1.9,
    "speedMin": 88,
    "speedMax": 108,
    "tip": "355",
    "material": "steel",
    "confidence": "MED"
  },
  "grafalloy-prolaunch-blue-iron-shaft": {
    "launch": "mid-high",
    "spin": "mid-high",
    "weightMin": 60,
    "weightMax": 75,
    "torque": 3.8,
    "speedMin": 68,
    "speedMax": 90,
    "tip": "370",
    "material": "graphite",
    "confidence": "MED"
  },
  "true-temper-xp-105-steel-shaft": {
    "launch": "mid",
    "spin": "mid",
    "weightMin": 100,
    "weightMax": 108,
    "torque": 2.0,
    "speedMin": 84,
    "speedMax": 104,
    "tip": "355",
    "material": "steel",
    "confidence": "HIGH"
  },
  "fst-original-36-steel": {
    "launch": "mid",
    "spin": "mid",
    "weightMin": 95,
    "weightMax": 115,
    "torque": 2.0,
    "speedMin": 82,
    "speedMax": 108,
    "tip": "370",
    "material": "steel",
    "confidence": "LOW"
  },
  "project-x-rifle-steel-shaft-0-355-tip": {
    "launch": "mid",
    "spin": "mid",
    "weightMin": 115,
    "weightMax": 125,
    "torque": 1.8,
    "speedMin": 90,
    "speedMax": 112,
    "tip": "355",
    "material": "steel",
    "confidence": "HIGH"
  }
};